import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import {
    TERMS_AND_CONDITIONS_ANZ_LIBRARY,
    TERMS_AND_CONDITIONS_ANZ_SCHOOL,
    TERMS_AND_CONDITIONS_UK
} from './TermsAndConditionsTexts';
import { useAuthentication } from '../../app-store/authentication/useAuthentication';

const StCenteredContainer = styled.div`
    font-size: 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

const TermsAndConditions: FC = () => {
    const {
        spoc: { distributionTerritory: territory }
    } = useAuthentication();
    let content: ReactNode;

    if (['AU_SCH', 'NZ_SCH'].includes(territory)) {
        content = TERMS_AND_CONDITIONS_ANZ_SCHOOL;
    } else if (['AU_LIB', 'NZ_LIB'].includes(territory)) {
        content = TERMS_AND_CONDITIONS_ANZ_LIBRARY;
    } else {
        content = TERMS_AND_CONDITIONS_UK;
    }

    return <StCenteredContainer className="content-area-inner">{content}</StCenteredContainer>;
};

export default TermsAndConditions;
